import React from "react";
import MaintenanceSchedulesCalendar from "./MaintenanceSchedulesCalendar";

function MaintenanceSchedulesCalendarView({
    devices,
    selectedRows,
    onSelectedRowsChange,
    onRefresh,
    onEventClick,
    filterText,
}) {
    return (
        <MaintenanceSchedulesCalendar
            devices={devices}
            onRefresh={onRefresh}
            onEventClick={onEventClick}
            filterText={filterText}
        />
    );
}

export default MaintenanceSchedulesCalendarView;
